export const BUSINESS_QUERY_PARAM = 'business_id';
